import { ChefHat, Sofa, Bath, Bed, Trees, Baby, Refrigerator, Frame } from "lucide-react";

/* Catalog categories - shared between Shop, Wishlist picker, ProductDetail */
export const CATEGORIES = [
  { slug: "cuisine", icon: ChefHat, color: "#D81B8C" },
  { slug: "salon", icon: Sofa, color: "#6B2C8F" },
  { slug: "salle_de_bain", icon: Bath, color: "#3FA535" },
  { slug: "chambre", icon: Bed, color: "#D81B8C" },
  { slug: "jardin", icon: Trees, color: "#3FA535" },
  { slug: "layette", icon: Baby, color: "#D81B8C" },
  { slug: "electromenager", icon: Refrigerator, color: "#6B2C8F" },
  { slug: "deco", icon: Frame, color: "#D81B8C" },
];

export const CATEGORY_LABELS_FR = {
  cuisine: "Cuisine",
  salon: "Salon",
  salle_de_bain: "Salle de bain",
  chambre: "Chambre",
  jardin: "Jardin",
  layette: "Layette",
  electromenager: "Électroménager",
  deco: "Décoration",
  special: "Cadeaux spéciaux",
};

export const CATEGORY_LABELS_EN = {
  cuisine: "Kitchen",
  salon: "Living room",
  salle_de_bain: "Bathroom",
  chambre: "Bedroom",
  jardin: "Garden",
  layette: "Baby",
  electromenager: "Appliances",
  deco: "Decor",
  special: "Special gifts",
};

export function categoryLabel(slug, lang) {
  const dict = lang === "fr" ? CATEGORY_LABELS_FR : CATEGORY_LABELS_EN;
  return dict[slug] || slug;
}

export function categoryMeta(slug) {
  return CATEGORIES.find((c) => c.slug === slug);
}
